import { Link } from 'react-router-dom';
import { FC, memo, ReactNode } from 'react';
import { Button } from 'antd';

import { Header } from '../../ui/Header';
import { LogoType } from '../../ui/LogoType';
import { ProfileButton } from '../../ui/ProfileButton';
import { LanguageSwitcher } from '../../ui/LanguageSwitcher';

import { useTranslate } from 'hooks';

import Utils from 'utils/utils';

import styles from './index.module.scss';

type NotFoundLayoutProps = {
	children: ReactNode;
	email?: string;
};

const NotFoundLayout: FC<NotFoundLayoutProps> = memo(({ children, email }) => {
	const { loginText, registerText } = useTranslate(['loginText', 'registerText']);

	return (
		<div className={styles.root}>
			<div className={styles.content}>
				<Header email={email} notFound>
					<>
						<a href={Utils.getLinkToWP('')}>
							<LogoType />
						</a>
						<div className={styles.row}>
							{email ? (
								<ProfileButton email={email} />
							) : (
								<>
									<Link to={'/'} className={styles.login}>
										{loginText}
									</Link>

									<Link to={'/register'}>
										<Button type="default" className={styles.register}>
											{registerText}
										</Button>
									</Link>
								</>
							)}

							<LanguageSwitcher />
						</div>
					</>
				</Header>

				<div className={styles.center}>{children}</div>
			</div>
		</div>
	);
});

export { NotFoundLayout };
